import { useEffect, useRef } from 'react'
import { router } from '@inertiajs/react'

interface UsePollUntilOptions {
  maxAttempts?: number
  onError?: () => void
}

export function usePollUntil (active: boolean, intervalMs: number, options: UsePollUntilOptions = {}): void {
  const { maxAttempts, onError } = options
  const attemptsRef = useRef(0)

  useEffect(() => {
    if (!active) {
      attemptsRef.current = 0
      return
    }
    const timer = setInterval(() => {
      if (maxAttempts != null && attemptsRef.current >= maxAttempts) {
        clearInterval(timer)
        onError?.()
        return
      }
      attemptsRef.current += 1
      router.reload()
    }, intervalMs)
    return () => clearInterval(timer)
  }, [active, intervalMs, maxAttempts, onError])
}
